import type { Store } from 'vuex';

import type { RootState } from '@/interfaces/store';

// To avoid circular dependencies
let storeInstance: Store<RootState> | null = null;

export function getStore() {
    if (storeInstance) return storeInstance;

    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const storeModule = require('@/store');
        storeInstance = storeModule.getStoreInstance();
        return storeInstance;
    } catch (error) {
        console.error('Error getting store:', error);
        return null;
    }
}
